export enum CookieBannerActionType {
    CookieBannerShown = 'Cookie Banner Shown',
    CookieConsent = 'Cookie Consent'
}
